module.exports = __webpack_public_path__ + "media/svg/CheckSquareFil-info-52c7e3d5.svg";